// HKDSE Type C (史傳散文) Q&A Data
// C1. 司馬遷《廉頗藺相如列傳》

export const hkdseTypeCQAData = {
  'hkdse-c1-simaqian-lianpo-linxiangru': {
    title: '司馬遷《廉頗藺相如列傳》問答題精選',
    sections: {
      paragraphStructure: {
        title: '段落重點整理',
        content: [
          {
            subtitle: '第一部分：完璧歸趙',
            points: [
              {
                title: '藺相如',
                items: ['出身卑微但智勇雙全，臨危受命，巧妙周旋於秦王與趙王之間，最終「完璧歸趙」，保全國體。']
              },
              {
                title: '廉頗',
                items: ['勇猛善戰，為趙國立下赫赫戰功，是趙國的名將。']
              },
              {
                title: '秦王',
                items: ['驕傲狡詐，表面以城易璧，實為欺騙。']
              }
            ]
          },
          {
            subtitle: '第二部分：澠池之會',
            points: [
              {
                title: '藺相如',
                items: ['面對秦王壓迫，臨危不懼，巧語應對，捍衛趙國尊嚴。']
              },
              {
                title: '廉頗',
                items: ['深明大義，為趙王設下三十日不還即立太子為王之計，保國為重。']
              },
              {
                title: '趙王',
                items: ['優柔寡斷，畏懼秦國，但能用人唯才，聽取賢臣意見。']
              }
            ]
          },
          {
            subtitle: '第三部分：負荊請罪',
            points: [
              {
                title: '廉頗',
                items: [
                  '初時心胸狹窄，妒忌相如功高位重，多次揚言要羞辱藺相如；',
                  '後感相如大度為國，主動負荊請罪，知錯能改，最終與藺相如「刎頸之交」。'
                ]
              },
              {
                title: '藺相如',
                items: ['寬宏大量，處處以國家大局為重，對廉頗處處忍讓，化解內部矛盾。']
              }
            ]
          }
        ]
      },
      characterAnalysis: {
        title: '角色性格整理',
        content: [
          {
            title: '藺相如',
            traits: ['智勇雙全、忠君愛國、謙遜忍讓、顧全大局']
          },
          {
            title: '廉頗',
            traits: ['勇猛善戰、率直魯莽、知錯能改、重義輕私']
          },
          {
            title: '秦王',
            traits: ['狡詐無信、心胸狹窄、權謀多端']
          },
          {
            title: '趙王',
            traits: ['優柔寡斷、能用人唯才']
          }
        ]
      },
      centralTheme: {
        title: '中心思想',
        content: [
          '透過廉頗與藺相如的矛盾化解，彰顯二人忠於國家、顧全大局的精神。',
          '讚揚藺相如智勇雙全、忍辱負重、以國為重的忠臣形象，亦肯定廉頗知錯能改的氣度。',
          '提醒為政者應用人唯才，國家興亡關鍵在於內部團結。'
        ]
      },
      selectedQuestions: {
        title: '問答題精選',
        questions: [
          {
            question: '藺相如與廉頗的關係經歷了哪些轉變？',
            answer: '最初廉頗因藺相如功高位重而心生不滿，多次揚言要羞辱相如。相如卻處處忍讓，顧全大局，最終廉頗感其高義，負荊請罪，二人成為生死之交。'
          },
          {
            question: '為何藺相如建議趙王可允秦王以十五城易璧的請求？',
            answer: '藺相如認為，若趙國拒絕，則理虧在趙；答應則理虧在秦。寧可讓秦國負上失信的惡名，亦不讓趙國失禮於天下。'
          },
          {
            question: '藺相如為何安排「齋戒五日、設九賓於廷」的條件？',
            answer: '藺相如深知秦王無意還城，故藉齋戒五日、設九賓於廷拖延時間，並安排屬下暗中帶璧逃回趙國，既保住國寶，也保全國體。'
          },
          {
            question: '「秦王齋五日後，乃設九賓禮於廷，引趙使者藺相如。」這句有何結構作用？',
            answer: '這句承上啟下，既交代前文藺相如如何設計拖延時間，也為後文揭示秦王無信、趙國得以保璧作鋪墊，推動情節發展。'
          },
          {
            question: '如何評價藺相如「先國家之急而後私讎」的處世態度？',
            answer: '藺相如以國家利益為先，個人恩怨為後，能忍受侮辱、寬容大度，真正展現忠臣風範。這種精神值得後人學習。'
          },
          {
            question: '文章如何通過角色描寫突出主旨？',
            answer: '作者通過多角度描寫藺相如的智謀與大度、廉頗的勇猛與知錯能改，以及秦王的狡詐無信，突顯忠臣愛國、知錯能改、團結一致的重要性，對後世有很大啟示。'
          }
        ]
      }
    }
  }
};

export const getTypeCQAByTextId = (textId) => {
  return hkdseTypeCQAData[textId] || null;
}; 